import React from "react";
import { Button } from "@chakra-ui/react";
import { IoTrashBinOutline } from "react-icons/io5";
import { Modal } from "components";
import { SelectionContext } from "../../../../duck";
import { useDeleteAuthorizationSettings } from "./duck";

const Remove: React.FC = () => {
  const { selected, select } = React.useContext(SelectionContext);
  const onConfirm = useDeleteAuthorizationSettings(selected, () => select([]));

  return (
    <Modal.Confirm
      onConfirm={onConfirm}
      successMessage={
        selected.length > 1
          ? "Authorization conditions are deleted successfully."
          : "Authorization condition is deleted successfully."
      }
      title="Delete Authorization condition"
      body="Are you sure you want to delete? You can’t undo this action afterwards."
    >
      <Button
        disabled={selected.length === 0}
        leftIcon={<IoTrashBinOutline />}
        colorScheme="red"
      >
        Remove
      </Button>
    </Modal.Confirm>
  );
};

export default Remove;
